module.exports = __webpack_public_path__ + "static/guidance-267ce88c46517bc359d7cc20e9018102.png";